import React from "react";

import IdBadge2OutlineIcon from "@src/lib/icons/18px/id-badge-2-outline";
import { SidebarMenuItem, SidebarMenuButton } from "@src/lib/ui/Sidebar";
import Link from "next/link";
import { useRouter } from "next/router";

const AdminLeftNavRolesMenuButton: React.FC = () => {
  const { pathname } = useRouter();
  const isActive = pathname.startsWith("/roles");
  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        asChild
        tooltip="Roles"
        dataTestId="roles-button"
        isActive={isActive}
      >
        <Link href="/roles">
          <IdBadge2OutlineIcon />
          Roles
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};

export default AdminLeftNavRolesMenuButton;
